import styled from "styled-components";
import { Tooltip, Text } from '@blueprint/ui';

const StyledToolTip = styled(Tooltip)`
    position: relative;
`;

const StyledCTA = styled.div`
    position: static;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 4px;
    background-color: var(--bs-red);
    border-radius: 50%;
`

type UserDetailTooltipProps = {
    className?: string;
    newData?: string;
    oldData: string;
};

export const UserDetailTooltip = ({
    className,
    newData,
    oldData,
}: UserDetailTooltipProps): JSX.Element => {
    if (!newData || newData === oldData) {
        return <dd className={className}>{oldData}</dd>;
    }
    return (
        <StyledToolTip
            id="viewDataTooltipHover"
            placement="right"
            trigger={'hover'}
            tooltip={<Text variant="body2">{oldData}</Text>}
        >
            <StyledCTA title="action required" aria-label="action required"/><dd className={className}>{newData}</dd>
        </StyledToolTip>
    );
};

